import { Check, User, Users, Users2, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { useSite } from "@/context/SiteContext";

export default function Packages() {
  const { content, openBooking } = useSite();
  const pkgs = content.packages?.packages || [];

  return (
    <section
      id="packages"
      className="section-pad relative overflow-hidden text-white"
      style={{ backgroundImage: "url(/packages-bg.png)", backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ backgroundImage: "url(/packages-bg.png)", backgroundSize: "cover", backgroundPosition: "center", filter: "blur(20px)", transform: "scale(1.12)" }}
      />
      <div aria-hidden="true" className="absolute inset-0 bg-[rgba(5,13,26,0.72)]" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10">
        <Reveal direction="left">
          <div className="eyebrow text-[#00CFFF] mb-4">Support that fits your goals</div>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-[46px] tracking-tight leading-[1.12]">
            Flexible ways to <span className="text-[#00CFFF]">work</span> with us.
          </h2>
          <p className="mt-4 text-white/85 text-base sm:text-lg max-w-2xl leading-relaxed">
            Whether you need occasional help or a dedicated team, we have a solution that fits.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-8 items-stretch">
          {pkgs.map((p, i) => {
            const rec = p.recommended;
            const Icon = i === 0 ? User : i === 1 ? Users : Users2;
            return (
              <Reveal key={p.name} direction="up" delay={i * 0.12} className="h-full">
                <div
                  className={`h-full rounded-2xl p-8 flex flex-col text-center backdrop-blur-md transition-all duration-300 hover:-translate-y-1.5 ${rec
                    ? "bg-[rgba(8,20,40,0.72)] border-[1.5px] border-[rgba(0,207,255,0.75)] shadow-[0_0_46px_rgba(0,207,255,0.28),0_24px_60px_rgba(0,0,0,0.45)]"
                    : "bg-[rgba(8,20,40,0.6)] border border-white/10 shadow-[0_18px_50px_rgba(0,0,0,0.35)]"}`}
                  data-testid={rec ? "package-card-recommended" : `package-card-${i}`}
                >
                  <div className="flex justify-center">
                    <Icon size={46} className="text-[#4DA3FF]" fill="currentColor" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-5 font-display font-extrabold text-[22px] text-white">{p.name}</h3>
                  <p className="mt-2 text-[15px] text-white/75 leading-relaxed">{p.description}</p>
                  <div className="my-6 border-t border-white/10" />
                  <ul className="space-y-3.5 flex-1 text-left">
                    {(p.items || []).map((item) => (
                      <li key={item} className="flex items-start gap-3 text-[14.5px] text-white/85">
                        <span className="w-[19px] h-[19px] rounded-full bg-[rgba(0,207,255,0.14)] border border-[rgba(0,207,255,0.4)] flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Check size={11} className="text-[#00CFFF]" strokeWidth={3.5} />
                        </span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() => openBooking(p.name, "quote")}
                    className={`btn w-full mt-8 ${rec ? "" : "btn-outline-light"}`}
                    style={rec ? { background: "#00CFFF", color: "#062033", boxShadow: "0 0 30px rgba(0,207,255,0.4)" } : undefined}
                    data-testid={`package-cta-${i}`}
                  >
                    Request a quote
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
